import { render, staticRenderFns } from "./TemplateCreateAuto.vue?vue&type=template&id=5296746a&"
import script from "./TemplateCreateAuto.vue?vue&type=script&lang=js&"
export * from "./TemplateCreateAuto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports